// Chat components...
Vue.component('ChatSection', require('@app/chat/components/chat/ChatSection.vue').default)
Vue.component('ChatWidget', require('@app/chat/components/widget/ChatWidget.vue').default)
Vue.component('ChatTemplates', require('@app/chat-templates/components/TemplatesSelection.vue').default)
Vue.component('ChatTemplatesCreate', require('@app/chat-templates/components/TemplateCreate.vue').default)
Vue.component('ChatTemplatesEdit', require('@app/chat-templates/components/TemplateEdit.vue').default)
Vue.component('ChatTemplatesDelete', require('@app/chat-templates/components/TemplateDelete.vue').default)

// Auth components...
Vue.component('RegisterForm', require('@app/auth/components/RegisterForm.vue').default)
Vue.component('RegisterRoleForm', require('@app/auth/components/RegisterRoleForm.vue').default)
Vue.component('LoginForm', require('@app/auth/components/LoginForm.vue').default)
Vue.component('NewPasswordForm', require('@app/auth/components/NewPasswordForm.vue').default)
Vue.component('PasswordChangeForm', require('@app/user/components/PasswordChangeForm.vue').default)
Vue.component('PartnerRegisterForm', require('@app/auth/components/PartnerRegisterForm.vue').default)

// Dashboard components...
Vue.component('CompleteHabit', require('@app/dashboard/components/CompleteHabit.vue').default)
Vue.component('CompleteHabitSuccess', require('@app/dashboard/components/HabitSucceededModal.vue').default)
Vue.component('CompleteHabitFailed', require('@app/dashboard/components/HabitFailedModal.vue').default)

// Recipes components...
Vue.component('RecipesView', require('@app/recipes/components/RecipesView.vue').default)

// Progress components...
Vue.component('StepsTabContent', require('@app/progress/components/StepsTabContent.vue').default)

// Notes components...
Vue.component('NotesModal', require('@app/notes/components/NotesModal.vue').default)
Vue.component('NotesFormSidebar', require('@app/notes/components/NotesFormSidebar.vue').default)

// Forum components...
Vue.component('LikeHeart', require('@app/forum/components/LikeHeart.vue').default)
Vue.component('EmojiIcon', require('@app/chat/components/chat/emoji/EmojiIcon.vue').default)
Vue.component('Notifications', require('@app/forum/components/Notifications.vue').default)

// Consultations components...
Vue.component('ConsultationReserve', require('@app/consultations/components/ConsultationReserve.vue').default)

// Coaches components...
Vue.component('CoachesAvailability', require('@app/coaches/components/CoachAvailability/CoachAvailability.vue').default)
Vue.component('CoachesMyPanelTasks', require('@components/Coaches/MyPanel/MyPanelTasks.vue').default)

// Coach Admin components...
Vue.component('CoachesList', require('@app/coach-admin/components/CoachesList/CoachesList.vue').default)
Vue.component('CoachAdminLocaleSwitch', require('@components/CoachAdmin/Navigation/CoachAdminLocaleSwitch.vue').default)
Vue.component('CoachDetail', require('@app/coach-admin/components/CoachDetail/CoachDetail.vue').default)
Vue.component('CoachCreateEdit', require('@app/coach-admin/components/CoachCreateEdit/CoachCreateEdit.vue').default)

Vue.component('PatientSearch', require('@app/coach-admin/components/PatientSearch/PatientSearch.vue').default)

Vue.component('PatientModalAnonymize', require('@app/coach-admin/components/PatientSearch/PatientModalAnonymize.vue').default)

Vue.component('PatientModalMovePatient', require('@app/coach-admin/components/PatientMove/PatientModalMovePatient.vue').default)

// Coach availability components...
Vue.component('CoachExtraAvailabilityForm', require('@app/coach-availability/components/CoachExtraAvailabilityForm.vue').default)

Vue.component(
    'CoachAvailabilityCalendar',
    require('@app/coach-availability/components/CoachAvailabilityCalendar.vue').default
)
Vue.component('CoachAvailabilityForm', require('@app/coach-availability/components/CoachAvailability.vue').default)

// Forms components...
Vue.component('FormVerifyEmail', require('./components/FormsWeb/FormVerifyEmail.vue').default)

// User
Vue.component('UnitList', require('@app/user/components/Unit/UnitList.vue').default)
Vue.component('UnitListItem', require('@app/user/components/Unit/UnitListItem.vue').default)
Vue.component('UnitModal', require('@app/user/components/Unit/UnitModal.vue').default)
Vue.component('UnitModalInput', require('@app/user/components/Unit/UnitModalInput.vue').default)

// Reporting dashboard
Vue.component('InvitedUsers', require('@app/reporting/components/InvitedUsers.vue').default)
Vue.component('Parameters', require('@app/reporting/components/Parameters.vue').default)
Vue.component('UsersFunnel', require('@app/reporting/components/UsersFunnel.vue').default)
Vue.component('Doctors', require('@app/reporting/components/Doctors.vue').default)
Vue.component('FilterDashboard', require('@app/reporting/components/Filter.vue').default)

// Others components...
Vue.component('FeedbackForm', require('./app/others/components/FeedbackForm.vue').default)

// Components
Vue.component('DropdownControl', require('./components/DropdownControl.vue').default)
Vue.component('SearchFilter', require('./components/PatientsMatrix/Filters/SearchFilter.vue').default)
Vue.component('FormDownloadApp', require('./components/FormsWeb/FormDownloadApp.vue').default)
Vue.component('DownloadAppBtn', require('./components/Web/DownloadAppBtn.vue').default)

// Meals
Vue.component('MealsTab', require('./components/Meals/MealsTab.vue').default)

//Mailing
Vue.component('MailingUnsubscribe', () => import('./components/Web/MailingUnsubscribe.vue'))
